// extracted by mini-css-extract-plugin
module.exports = {"main":"AcquistiOnlineHubTemplate_main__jnNpF","list":"AcquistiOnlineHubTemplate_list__IQ1_A","rotation":"AcquistiOnlineHubTemplate_rotation__96qMR"};